import apiClient, { refreshMediaSession } from './apiClient';

const root = '/api/generations';
export const newCommandKey = () => crypto.randomUUID();
export function errorMessage(error) {
  const detail = error?.response?.data?.detail;
  return (typeof detail === 'string' ? detail : detail?.message) || 'Could not reach the service. Please try again.';
}
export const isMissingMedia = error => [404, 410].includes(error?.response?.status);
export const mediaErrorMessage = error => isMissingMedia(error) ? 'This asset is no longer available.' : errorMessage(error);
export const mediaUrl = (jobId, artifactId, download = false) =>
  `${process.env.REACT_APP_BACKEND_URL || ''}${root}/${encodeURIComponent(jobId)}/artifacts/${encodeURIComponent(artifactId)}/content${download ? '?download=true' : ''}`;

const generationApi = {
  create: async (form, key) => (await apiClient.post(root, form, { headers: { 'Idempotency-Key': key } })).data,
  history: async (signal) => (await apiClient.get(root, { signal })).data,
  prepareMedia: refreshMediaSession,
  get: async (id, signal) => (await apiClient.get(`${root}/${encodeURIComponent(id)}`, { signal })).data,
  artifacts: async (id, signal) => (await apiClient.get(`${root}/${encodeURIComponent(id)}/artifacts`, { signal })).data,
  accept: async (id, action, key) => (await apiClient.post(`${root}/${encodeURIComponent(id)}/image-acceptance`,
    { image_attempt_id: action.image_attempt_id, action_token: action.action_token }, { headers: { 'Idempotency-Key': key } })).data,
  cancel: async (id) => (await apiClient.post(`${root}/${encodeURIComponent(id)}/cancel`)).data,
  media: async (id, artifactId) => (await apiClient.get(mediaUrl(id, artifactId), { responseType: 'blob' })).data,
};
export default generationApi;
